module.exports = __webpack_public_path__ + "img/dr-lynne-mouw-mouw-family-chiropractic.f4c7cc9c.jpg";